export interface SqlitePersistenceStatus {
  available: boolean;
  path?: string;
  schemaVersion?: number;
  encrypted?: boolean;
  encryptionPending?: boolean;
  dexiePrimary?: boolean;
  persistenceEngine?: 'dexie' | 'sqlite';
  storageProfile?: string | null;
  migrationStatus?: string | null;
  reason?: string;
}

/** Pont renderer → processus principal pour l’état SQLite. */
export async function getSqlitePersistenceStatus(): Promise<SqlitePersistenceStatus> {
  const api = window.electron?.sqliteStatus;
  if (!api) {
    return { available: false, reason: 'hors Electron', dexiePrimary: true };
  }
  return api();
}
